module.exports = __webpack_public_path__ + "static/media/Cooking Crafty.6c0d8a60.jpg";